export const STATUS_CHANGED = "books/statusChanged";
export const SEARCH_CHANGED = "books/searchChanged";
